import Vue from "vue";
import Router from "vue-router";

import Login from "../views/login";
import Home from "../views/home";
import NotFound from "../views/NotFound";
import Html from "../views/child/Html";
import Bill from "../views/child/Bill";
import Remark from "../views/child/Remark";
import Php from "../views/child/Php";
import Mysql from "../views/child/Mysql";
import Chaodai from "../views/wenxue/Chaodai";
import Icon from "../views/wenxue/Icon";
import Author from "../views/wenxue/Author";
import Shici from "../views/wenxue/Shici";
import Shuf from "../views/wenxue/Shuf";
import Category from "../views/wenxue/Category";
import Travel from "../views/wenxue/Travel";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/",
      name: "Home",
      component: Home,
      children: [
        {
          path: "/html",
          name: "Html",
          component: Html,
        },
        {
          path: "/php",
          name: "Php",
          component: Php,
        },
        {
          path: "/mysql",
          name: "Mysql",
          component: Mysql,
        },
        {
          path: "/bill",
          name: "Bill",
          component: Bill,
        },
        {
          path: "/remark",
          name: "Remark",
          component: Remark,
        },
        {
          path: "/chaodai",
          name: "Chaodai",
          component: Chaodai,
        },
        {
          path: "/icon",
          name: "Icon",
          component: Icon,
        },
        {
          path: "/author",
          name: "Author",
          component: Author,
        },
        {
          path: "/shici",
          name: "Shici",
          component: Shici,
        },
        {
          path: "/shuf",
          name: "Shuf",
          component: Shuf,
        },
        {
          path: "/category",
          name: "Category",
          component: Category,
        },
        {
          path: "/travel",
          name: "Travel",
          component: Travel,
        },
        {
          path: "/user",
          name: "User",
          component: () => import("../views/wenxue/user"),
        },
        {
          path: "/pay",
          name: "Pay",
          component: () => import("../views/wenxue/pay"),
        },
        {
          path: "/salary",
          name: "Salary",
          component: () => import("../views/salary/index"),
        },
      ],
    },
    {
      path: "*",
      component: NotFound,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js